module.exports = __webpack_public_path__ + "img/type_ELECTRIC.d8fec9e6.png";